import styled from 'styled-components';

export interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}

const Track = styled.button<{ $on: boolean }>`
  position: relative; width: 38px; height: 22px; flex: none;
  border: 1px solid ${({ theme, $on }) => ($on ? 'transparent' : theme.color.glassBorder)};
  border-radius: ${({ theme }) => theme.radius.pill}; cursor: pointer; padding: 0;
  /* Off uses a surface token, not textMuted. A control track painted with a
     TEXT colour reads as a disabled label and drifts whenever type contrast is
     tuned. On is the accent fill alone; the halo is gone. */
  background: ${({ theme, $on }) => ($on ? theme.color.accentCyan : theme.color.hairSoft)};
  &:disabled { opacity: 0.5; cursor: not-allowed; }
  &::after {
    content: ''; position: absolute; top: 2px; left: ${({ $on }) => ($on ? '18px' : '2px')};
    width: 16px; height: 16px; border-radius: 50%; background: #fff; transition: left 140ms ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  }
`;

export function Switch({ checked, onChange, label, disabled }: SwitchProps) {
  return (
    <Track
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      $on={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    />
  );
}
